module.exports = __webpack_public_path__ + "static/media/gateway-placeholder.1f83549d.svg";